module.exports = __webpack_public_path__ + "media/images/static/common/bg_connect_a-636b0ff8e5db45cde7344507fa36802b.png";